import { CoreAPI } from '../../core';

/** 设置舞台模糊 */
export class BlurStage {
    /** 快捷操作菜单打开事件 */
    private eventName = 'gs-blur-stage';
    private blur = 0;

    constructor(private identity: string) {}

    /** 获取模糊 */
    getBlur() {
        return this.blur;
    }

    /** 添加模糊 */
    setBlur(blur = 30) {
        this.blur = blur;
        CoreAPI(this.identity).events.emit(this.eventName, blur);
    }

    /** 监听模糊 */
    onBlur(callback: (blur: number) => void) {
        const coreApi = CoreAPI(this.identity);
        const handler = coreApi.events.on(this.eventName, callback);
        return () => {
            coreApi.events.off(handler);
        };
    }

    /** 销毁 */
    destroy() {
        this.setBlur(0);
    }
}
